import { render, staticRenderFns } from "./AuthForm.vue?vue&type=template&id=911a8b00&scoped=true&"
import script from "./AuthForm.vue?vue&type=script&lang=js&"
export * from "./AuthForm.vue?vue&type=script&lang=js&"
import style0 from "./AuthForm.vue?vue&type=style&index=0&id=911a8b00&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "911a8b00",
  null
  
)

export default component.exports